import { FeatureItem } from '../types';

export const features: FeatureItem[] = [
  {
    icon: 'm',
    title: 'Components in days, not months',
    description: 'We deliver precision-grade machined parts in 5-21 days, depending on complexity and coatings/outside processes.'
  },
  {
    icon: 'insert',
    title: 'Ultra-reliable',
    description: 'Our advanced scheduling, capacity management and factory operating system enables us to meet our promise date and your need date every time.'
  },
  {
    icon: 'insert',
    title: 'Transparent',
    description: 'Real time visibility of your parts in our factory and supply chain, including inspection results as they happen, from FAI to Final.'
  }
];

export const navItems = [
  { label: 'Home', href: '/' },
  { label: 'Our Mission', href: '/mission' },
  { label: 'Blog', href: '/blog' }
];